export const INIT_USER_INFO = 'initUserInfo';
export const DISPATCH_INIT_USER_INFO = 'login/initUserInfo';

